import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Download Istantaneo', 'Nessun Abbonamento', 'Accesso a Vita', 'Garanzia di 7 Giorni'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-110" data-mp="9lbfqzxtf9d2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-111" data-mp="4m8mecr76rkx">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[1.9rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl sm:leading-[1.02] md:text-[3.75rem]" data-id="element-112" data-mp="4jm4pkalevoz">
          Risolvi un Intero Anno di Lezioni di Economia Aziendale in soli{' '}
          <span className="italic text-brand" data-id="element-113" data-mp="neaz5d0pxnpw">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-114" data-mp="3d2torapbqmf2">
          Unisciti a oltre 1.200 insegnanti che hanno smesso di improvvisare. Entra in classe con
          tutto pronto per spiegare, registrare e ispirare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-115" data-mp="3e8ms0wvuejdk">
          <img src="https://cdn.magicpatterns.com/uploads/mMv8m2HpPB2Rp4Dmwxsz6m/2d1dab59-a456-4edf-8cc4-6f65bd11fbea.webp" alt="Il pacchetto AZIENDALE PRONTA: i cinque volumi dal 1° al 5° anno della Secondaria con schemi contabili, casi aziendali, verifiche pronte all'uso e i 5 bonus strategici inclusi" className="mx-auto w-[68%] max-w-sm sm:w-[64%]" data-id="element-116" data-mp="2qjv96w457ddg" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-117" data-mp="s2jjlmv9pier">
          <CtaButton href="#offer" data-id="element-118" data-mp="id00cg3n7mjd" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-119" data-mp="i9vp4yrrfqj7">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-120" data-mp="1ayt7t2zvvpch" data-mpi={index}>
                <span data-id="element-121" data-mp="163472wc4o2el">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-122" data-mp="111ol9224lrv5">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}